import styled from 'styled-components';

export const GuestWrapper = styled.div`
  width: 100%;
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 10px;

  .responsive-room-delete-box {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
  }

  &:last-of-type {
    display: block;
  }
`;

export const GuestInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GuestInfo = styled.div`
  display: flex;
  align-items: flex-start;

  .guest-item-info-icon svg,
  .guest-item-info-icon path {
    font-size: 15px;
  }
`;

export const GuestTextWrapper = styled.div`
  margin-right: 6px;
  margin-top: -3px;
`;

export const GuestTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const GuestSubtitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.clearBlue};
`;

export const GuestChildAgePicker = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 100px;
  grid-gap: 0 20px;
  padding: 0 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
    padding: 0;
  }
`;
